import React, { useState } from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { useNavigation } from '../hooks/useNavigation';
import logo from '../assets/img/logo.png';

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(34, 34, 34, 0.95);
  backdrop-filter: blur(10px);
  z-index: 1000;
  padding: 0 2rem;
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba(186, 59, 59, 0.3);
`;

const HeaderContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  position: relative;
`;

const LogoButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

const Logo = styled.img`
  height: 50px;
  width: auto;
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 2rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled.button`
  background: none;
  border: none;
  color: #f0eadd;
  font-family: 'Arial Nova', Arial, Helvetica, sans-serif;
  font-size: 16px;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 4px;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.1em;

  &:hover {
    background: rgba(186, 59, 59, 0.8);
    color: #f0eadd;
  }

  &.active {
    background: #ba3b3b;
    color: #f0eadd;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 6px 12px;
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: #f0eadd;
  font-size: 24px;
  cursor: pointer;
  padding: 8px;
  position: absolute;
  right: 0;

  @media (max-width: 768px) {
    display: block;
  }
`;

const MobileMenu = styled.div`
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: rgba(34, 34, 34, 0.98);
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(186, 59, 59, 0.3);
  padding: 1rem;
  flex-direction: column;
  gap: 1rem;

  &.open {
    display: flex;
  }

  @media (max-width: 768px) {
    display: ${props => props.isOpen ? 'flex' : 'none'};
  }
`;

const Header = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { navigateToHome, navigateToCriticas, navigateToNovidades, navigateToColetivas, navigateToSection } = useNavigation();

  const handleNavigation = (action, sectionId = null) => {
    if (action === 'home') {
      navigateToHome();
      setIsMobileMenuOpen(false);
    } else if (action === 'criticas') {
      navigateToCriticas();
      setIsMobileMenuOpen(false);
    } else if (action === 'novidades') {
      navigateToNovidades();
      setIsMobileMenuOpen(false);
    } else if (action === 'coletivas') {
      navigateToColetivas();
      setIsMobileMenuOpen(false);
    } else if (action === 'section' && sectionId) {
      navigateToSection(sectionId);
      setIsMobileMenuOpen(false);
    }
  };

  const navItems = [
    { label: 'Sobre', action: 'section', sectionId: 'sobre' },
    { label: 'Críticas', action: 'criticas' },
    { label: 'Novidades', action: 'novidades' },
    // { label: 'Coletivas', action: 'coletivas' },
    // { label: 'Mídia Kit', action: 'section', sectionId: 'media-kit' },
    { label: 'Contato', action: 'section', sectionId: 'contato' }
  ];

  return (
    <HeaderContainer>
      <HeaderContent>
        <LogoButton onClick={() => handleNavigation('home')}>
          <Logo src={logo} alt="Quatro Takes" />
        </LogoButton>

        <Nav>
          {navItems.map((item, index) => (
            <NavLink
              key={index}
              onClick={() => handleNavigation(item.action, item.sectionId)}
              className={
                (location.pathname === '/criticas' && item.label === 'Críticas') ||
                (location.pathname === '/novidades' && item.label === 'Novidades') ||
                (location.pathname === '/coletivas' && item.label === 'Coletivas')
                  ? 'active' 
                  : ''
              }
            >
              {item.label}
            </NavLink>
          ))}
        </Nav>

        <MobileMenuButton onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          ☰
        </MobileMenuButton>
      </HeaderContent>

      <MobileMenu isOpen={isMobileMenuOpen}>
        {navItems.map((item, index) => (
          <NavLink
            key={index}
            onClick={() => handleNavigation(item.action, item.sectionId)}
            className={
              (location.pathname === '/criticas' && item.label === 'Críticas') ||
              (location.pathname === '/novidades' && item.label === 'Novidades') ||
              (location.pathname === '/coletivas' && item.label === 'Coletivas')
                ? 'active' 
                : ''
            }
          >
            {item.label}
          </NavLink>
        ))}
      </MobileMenu>
    </HeaderContainer>
  );
};

export default Header;
